// extracted by mini-css-extract-plugin
module.exports = {"overlay":"menu-module--overlay--3Q1oo","overlayHidden":"menu-module--overlayHidden--2win1"};